import React, { useState } from "react";
import { SummaryDetail } from "./SummaryDetail";
import { AllergiesDetail } from "./Allergies";
import { Problems } from "./Problems";
import { Medications } from "./Medications";

function NavItem({ active, setActive, isActive, children }) {
  return (
    <li>
      <a
        onClick={setActive}
        className={`block px-3 py-2 rounded-md ${
          isActive === active ? "bg-sky-500 text-white" : "bg-slate-50"
        }`}
      >
        {children}
      </a>
    </li>
  );
}

export const PatientDetail = () => {
  const [isActive, setIsActive] = useState("summary");

  return (
    <div className="divide-y divide-slate-100">
      <nav className="py-4 px-6 text-sm font-medium">
        <ul className="flex space-x-3">
          <NavItem
            isActive={isActive}
            active="summary"
            setActive={() => setIsActive("summary")}
          >
            Summary
          </NavItem>
          <NavItem
            isActive={isActive}
            active="problems"
            setActive={() => setIsActive("problems")}
          >
            Problems
          </NavItem>
          <NavItem
            isActive={isActive}
            active="medications"
            setActive={() => setIsActive("medications")}
          >
            Medications
          </NavItem>
        </ul>
      </nav>
      <SummaryDetail />
      <div className="flex justify-between">
        <div className="flex-auto w-50">
          <AllergiesDetail />
          <Problems />
        </div>
        <div className="flex-auto w-50">
          <Medications />
        </div>
      </div>
    </div>
  );
};
